import React from 'react';
import { Analytics } from '@gik/core/utils';
import { CreateAnalyticsEvents } from '@gik/create/hooks/useCreateAnalytics';
import { createPageFinishedKey } from '@gik/create/components/CreatePage/CreatePage';

// TODO: remove this after SPA migration - redirects will not interrupt events
export default function useCreatePageFinishedAnalytics(): void {
  React.useEffect(() => {
    const inkindRouteId = localStorage.getItem(createPageFinishedKey);
    if (inkindRouteId) {
      localStorage.removeItem(createPageFinishedKey);
      Analytics.fireEvent(
        CreateAnalyticsEvents.CREATE_FINISHED,
        {
          inkindRouteId,
        },
        keys => keys // only one key - inkindRouteId
      );
    }
  }, []);
}
